module.exports = __webpack_public_path__ + "img/agency-slide-01.3ed8ac29.jpg";